import { createFileRoute } from "@tanstack/react-router";
import { marketingHead } from "@/lib/marketing/seo";
import { breadcrumbs } from "@/lib/marketing/ppl-schema";
import { MarketingShell } from "@/components/marketing/site/marketing-shell";
import { MarketingCta } from "@/components/marketing/site/marketing-cta";
import { PricingHero } from "@/routes/v2/-components/pricing-hero";
import { PricingTerms } from "@/routes/v2/-components/pricing-terms";
import { PricingSource } from "@/routes/v2/-components/pricing-source";
import { PricingPlans } from "@/routes/v2/-components/pricing-plans";
import { PricingFaq } from "@/routes/v2/-components/pricing-faq";
import { pricingFaqs } from "@/routes/v2/-lib/pricing-data";

const PRICING_FAQ_SCHEMA = {
  "@type": "FAQPage",
  mainEntity: pricingFaqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

function MarketingPricing() {
  return (
    <MarketingShell>
      <PricingHero />

      <PricingTerms />

      <PricingSource />

      <PricingPlans />

      <PricingFaq />

      <MarketingCta
        title="The number takes thirty minutes"
        subtitle="Book the call and you leave with the figure for your operation, where your state stands, and the eMAR opened in front of you."
        primaryLabel="Get your number"
        primaryHref="/demo"
        secondaryLabel="Try it now, no account"
        secondaryHref="/experience"
      />
    </MarketingShell>
  );
}

export const Route = createFileRoute("/v2/pricing")({
  component: MarketingPricing,
  head: () => ({
    ...marketingHead({
      title: "Plans: everything about the price, except the number | PEOPLE AI Workforce",
      description:
        "The terms in full: month to month, add or drop any month, no setup or implementation fee, no per-bed or per-seat math, export at any time, no lock-in and no exit fee. PEOPLE Core is free, and each AI employee is its own subscription priced per community; the figure is quoted for your operation on a 30-minute call.",
      path: "/v2/pricing",
      imageAlt: "PEOPLE AI Workforce. The AI workforce for senior living",
      /* No Offer node: the page states no price, by decision, and an Offer
         with no figure is a claim with nothing in it. */
      schema: [PRICING_FAQ_SCHEMA, breadcrumbs({ name: "Pricing", path: "/pricing" })],
    }),
  }),
});
